import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { z } from "zod";

import { AppShell } from "@/components/app-shell/AppShell";
import { FormEditor } from "@/components/forms/FormEditor";
import { api } from "@/lib/api";

const searchSchema = z.object({
  site: z.string().optional(),
});

export const Route = createFileRoute("/forms/new")({
  validateSearch: searchSchema,
  component: NewFormPage,
});

function NewFormPage() {
  const { site } = useSearch({ from: "/forms/new" });
  const navigate = useNavigate();
  const sitesQ = useQuery({ queryKey: ["sites"], queryFn: () => api.listSites() });
  const sites = sitesQ.data?.sites ?? [];

  if (sitesQ.isLoading) {
    return (
      <AppShell title="New form">
        <div className="flex items-center gap-2 px-1 py-8 text-xs text-zinc-500">
          <Loader2 className="h-3.5 w-3.5 animate-spin" /> loading sites…
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell title="New form">
      <FormEditor
        mode="create"
        sites={sites}
        defaultSiteKey={site}
        onSaved={(f) =>
          navigate({ to: "/forms/$formKey", params: { formKey: f.formKey } })
        }
      />
    </AppShell>
  );
}
